import { PERKS, type PerkId } from '@xox/shared'
import { BottomSheet } from '../components/BottomSheet'

interface Props {
  perks: readonly PerkId[]
  onPick: (index: number) => void
}

/** The level-up choice: three perks, one pick, nothing else happens until then. */
export function PerkSheet({ perks, onPick }: Props) {
  return (
    <BottomSheet open={perks.length > 0} onClose={() => {}} title="Level up! Pick a perk">
      <ul className="flex flex-col gap-2">
        {perks.map((id, i) => (
          <li key={id}>
            <button
              type="button"
              onClick={() => onPick(i)}
              className="w-full rounded-2xl bg-white p-4 text-left shadow-sm ring-1 ring-slate-200 transition hover:ring-sky-400 active:scale-[0.99] dark:bg-slate-900 dark:ring-slate-700"
            >
              <span className="block font-black">{PERKS[id].name}</span>
              <span className="block text-sm text-slate-500">{PERKS[id].blurb}</span>
            </button>
          </li>
        ))}
      </ul>
    </BottomSheet>
  )
}
